module.exports = __webpack_public_path__ + "static/media/capri-10.abb5a228.jpg";